<div class="emds macros">
  <div class="row macro-row-padding">
    <div class="col-xs-12 col-md-8">
      <mat-form-field class="quick-search"
                      appearance="outline">
        <input matInput
               placeholder="Find Macros"
               [formControl]="macroNameFilterFormControl"
               #quickSearch
               type="text">
        <span matPrefix>
          <mat-icon>search</mat-icon>
        </span>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-4">
      <button *ngIf="!newHidden"
              class="macro-hints-btn btn btn-light pull-right"
              (click)="onNew()"
              [disabled]="isDisabled">
        + New
      </button>
    </div>
  </div>
  <div class="row macro-row-padding">
    <div class="col-xs-12">
      <ap-findcontrol [baseId]="Id + '-group'"
                      [findControlId]="findControlIdService.ListMacroGroupByUser"
                      [(selectedPks)]="groups"
                      [placeHolder]="'Select Macro Groups'"
                      [requiredSearchParameters]="findControlSearchParams"
                      (selectedPksChange)="onMacroGroupSelected($event)"
                      [singleSelect]="false">
      </ap-findcontrol>
    </div>
  </div>
  <div class="macro-list">
    <ul>
      <ng-container *ngIf="filteredMacros$ | async as macros; else noItems">
        <li class="macro-item"
            *ngFor="let macro of macros">
          <a (click)="onMacroSelected(macro)"
             [class.selected]="selectedMacro && macro.TransientUXId == selectedMacro.TransientUXId">
            {{macro.Name}}
          </a>
        </li>
      </ng-container>
      <ng-template #noItems>
        <p class="no-macros">No macros</p>
      </ng-template>
    </ul>
  </div>
  <div *ngIf="!hidden"
       class="macro-description">
    <button #insertBtn
            *ngIf="!insertHidden"
            class="macro-insert-btn btn btn-light"
            (click)="onInsert(insertBtn)">
      <mat-icon class="btn-icon">chevron_left</mat-icon> Insert
    </button>
    <button [class.hidden]="modifyAlwaysHidden || modifyHidden"
            class="macro-modify-btn btn btn-light"
            (click)="onModify()">Modify
    </button>
    <button [class.hidden]="modifyAlwaysHidden || modifyHidden"
            class="macro-clone-btn btn btn-light"
            (click)="onClone()">Clone
    </button>
    <button [class.hidden]="modifyAlwaysHidden || modifyHidden"
            class="macro-delete-btn btn btn-light"
            (click)="onDelete()">Delete
    </button>
    <br>
    <p class="selected-macro-group">{{selectedMacroDescriptionText}}</p>
    <h6>Description:</h6>
    <p *ngIf="selectedMacro"
       class="selected-macro-text"
       [innerHTML]="selectedMacro.Description">
    </p>
  </div>
</div>
